if (!customElements.get('gift-question')) {
  const ANSWER_KEY = 'Es para regalo';
  const MESSAGE_KEY = 'Mensaje de regalo';
  const VALID_ANSWERS = ['Sí', 'No'];

  const instances = new Set();
  const store = { initialised: false, answer: '', message: '', queue: Promise.resolve() };

  const isAnswered = () => VALID_ANSWERS.includes(store.answer);

  const updateGates = () => {
    const hasWidget = [...instances].some((instance) => instance.isConnected);
    document.querySelectorAll('.additional-checkout-buttons').forEach((container) => {
      container.classList.toggle('is-gated', hasWidget && !isAnswered());
    });
  };

  const saveAttributes = () => {
    const attributes = {
      [ANSWER_KEY]: store.answer,
      [MESSAGE_KEY]: store.answer === 'Sí' ? store.message.trim() : '',
    };
    const url = `${(window.routes && window.routes.cart_update_url) || '/cart/update'}.js`;

    // Serialised so rapid clicks never save out of order.
    store.queue = store.queue
      .then(() =>
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        })
      )
      .catch((error) => console.error('[gift-question] no se pudo guardar', error));
    return store.queue;
  };

  const renderAll = () => {
    instances.forEach((instance) => instance.isConnected && instance.render());
    updateGates();
  };

  class GiftQuestion extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.radios = [...this.querySelectorAll('.gift-question__radio')];
      this.messageWrapper = this.querySelector('.gift-question__message');
      this.textarea = this.querySelector('.gift-question__textarea');
      this.errorElement = this.querySelector('.gift-question__error');

      if (!store.initialised) {
        const checked = this.radios.find((radio) => radio.checked);
        store.answer = checked ? checked.value : '';
        store.message = this.textarea.value;
        store.initialised = true;
      }

      this.radios.forEach((radio) => radio.addEventListener('change', () => this.onAnswerChange(radio.value)));
      this.textarea.addEventListener('input', () => this.onMessageInput());
      this.textarea.addEventListener('change', () => this.onMessageCommit());

      instances.add(this);
      // The drawer is re-rendered by the server after quantity changes: the
      // client state wins so an answer is never lost or flickers.
      this.render();
      updateGates();
    }

    disconnectedCallback() {
      instances.delete(this);
      clearTimeout(this.debounce);
      updateGates();
    }

    render() {
      this.radios.forEach((radio) => {
        radio.checked = radio.value === store.answer;
      });
      this.messageWrapper.hidden = store.answer !== 'Sí';
      if (this.textarea.value !== store.message && document.activeElement !== this.textarea) {
        this.textarea.value = store.message;
      }
      if (isAnswered()) this.clearError();
    }

    onAnswerChange(value) {
      store.answer = value;
      if (value !== 'Sí') store.message = '';
      renderAll();
      saveAttributes();
    }

    onMessageInput() {
      store.message = this.textarea.value;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.onMessageCommit(), 600);
    }

    onMessageCommit() {
      clearTimeout(this.debounce);
      store.message = this.textarea.value;
      instances.forEach((instance) => instance !== this && instance.isConnected && instance.render());
      saveAttributes();
    }

    showError() {
      this.classList.add('is-invalid');
      this.errorElement.hidden = false;
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const target = this.radios[0];
      if (target) target.focus({ preventScroll: true });
    }

    clearError() {
      this.classList.remove('is-invalid');
      this.errorElement.hidden = true;
    }
  }

  customElements.define('gift-question', GiftQuestion);

  const widgetForForm = (form) =>
    form && [...instances].find((instance) => instance.isConnected && instance.formId === form.id);

  const blockIfUnanswered = (event, form) => {
    const widget = widgetForForm(form);
    if (!widget || isAnswered()) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    widget.showError();
    return true;
  };

  // Capture phase: runs before the browser's native validation and before any
  // theme/app handler that would send the customer to checkout.
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const checkoutButton = target.closest('[name="checkout"]');
      if (checkoutButton) {
        blockIfUnanswered(event, checkoutButton.form);
        return;
      }

      if (target.closest('.additional-checkout-buttons.is-gated')) {
        const cartPageWidget = widgetForForm(document.getElementById('cart'));
        if (cartPageWidget) {
          event.preventDefault();
          event.stopPropagation();
          cartPageWidget.showError();
        }
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') blockIfUnanswered(event, event.target);
    },
    true
  );
}
